import React, { useState } from 'react';
import { styles } from './HeaderNavigation.css';
import { Menu } from '../../../Menu/Menu';
import { MenuUnderlay } from '../../../Menu/MenuUnderlay/MenuUnderlay';
import { DropdownHeading } from '../../../Menu/MenuDropdown/DropdownHeading/DropdownHeading';
import { BaseMenuItem, MenuData } from '../../../Menu/types';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { MenuItem } from '../../../Menu/MenuItem/MenuItem';
import { useTrackingContext } from '../../../Tracking';

export type HeaderNavigationProps = {
  menuItems: Array<MenuData>;
  mobileNavMenuItems?: Array<BaseMenuItem>;
  isSnackbarVisible?: boolean;
};

export const HeaderNavigation = ({ menuItems, mobileNavMenuItems, isSnackbarVisible }: HeaderNavigationProps) => {
  const [activeMenu, setActiveMenu] = useState<number | null>(null);
  const isDesktop = useBreakpoint('md', 'up');
  const { tracker } = useTrackingContext();

  const handleToggle = (menuIndex: number | null, menuData?: MenuData) => {
    if (menuData && activeMenu !== menuIndex) {
      tracker?.trackCustomEvent({
        event: `custom.menu.click`,
        group: tracker.group,
        label: menuData.label,
        type: menuData.href ? 'open' : 'expand',
        info: {
          ...(menuData?.href ? { url: menuData?.href } : {}),
        },
      });
    }
    if (activeMenu === menuIndex) {
      tracker?.trackCustomEvent({
        event: `custom.menu.click`,
        group: tracker.group,
        type: 'back',
      });
      return setActiveMenu(null);
    }
    setActiveMenu(menuIndex);
  };

  const handleMobileUtilityClick = (_e: React.MouseEvent, menuItem: BaseMenuItem) => {
    tracker?.trackCustomEvent({
      event: `custom.menu.click`,
      group: tracker.group,
      value: menuItem.href,
      name: menuItem.label,
      info: {
        url: menuItem.href,
      },
    });
  };

  return (
    <nav
      className={styles.container({ hasOpenSubMenus: activeMenu !== null, isSnackbarVisible })}
      data-testid="navigation-menu"
    >
      <MenuUnderlay isOpen={activeMenu !== null} onClick={() => handleToggle(null)} />
      <div className={styles.menu} data-testid="navigation-menu">
        <ul className={styles.itemContainer} data-testid="navigation-menu-item-container">
          <DropdownHeading label="Main menu" />
          {menuItems.map((menuData, i) => (
            <Menu
              key={i}
              menuData={menuData}
              onToggle={() => handleToggle(i, menuData)}
              isOpen={i === activeMenu}
              isSnackbarVisible={isSnackbarVisible}
            />
          ))}
        </ul>
      </div>
      {!isDesktop && mobileNavMenuItems && activeMenu === null ? (
        <div className={styles.mobileMenu} data-testid="navigation-mobile-menu">
          <ul className={styles.itemContainer} data-testid="navigation-mobile-item-container">
            {mobileNavMenuItems?.map((mobileMenuItem, i) => (
              <MenuItem
                key={i}
                type={mobileMenuItem.type}
                label={mobileMenuItem.label}
                href={mobileMenuItem.href}
                onClick={e => handleMobileUtilityClick(e, mobileMenuItem)}
                leftIcon={mobileMenuItem.icon}
                isBold={mobileMenuItem.isBold}
                shouldHideArrow
                isSnackbarVisible={isSnackbarVisible}
              />
            ))}
          </ul>
        </div>
      ) : null}
    </nav>
  );
};
